import {
  googleMapsApiKey,
  mapProvider,
  osmNominatimUrl,
  osmOsrmUrl,
  osmPhotonUrl,
} from '../environment';

export type MapProvider = 'google' | 'osm';

export type OsmEndpoints = {
  nominatimUrl: string;
  photonUrl: string;
  osrmUrl: string;
};

export type GeoConfig = {
  provider: MapProvider;
  googleApiKey: string;
  osm: OsmEndpoints;
};

export type RawGeoEnv = {
  mapProvider?: string;
  googleMapsApiKey?: string;
  nominatimUrl?: string;
  photonUrl?: string;
  osrmUrl?: string;
};

// Зона поиска подсказок адресов
export const SEARCH_AREA = {
  // 57°09′ с. ш., 34°36′ в. д.
  lat: 57.15,
  lng: 34.6,
  radiusKm: 280,
  countryCode: 'RU',
};

// Приоритет близости к центру SEARCH_AREA в Photon.
// zoom — масштаб карты, задающий радиус «близко» (меньше — шире); по умолчанию 12.
// Меньшие значения размывают приоритет: при 9 ближайший к центру Торжок уходил из выдачи.
// locationBiasScale — вес известности места против близости: 0 — почти только близость,
// 1 — поровну; по умолчанию 0.4.
export const PHOTON_LOCATION_BIAS = {
  zoom: 12,
  locationBiasScale: 0.1,
};

const DEFAULT_OSM_ENDPOINTS: OsmEndpoints = {
  nominatimUrl: 'https://nominatim.openstreetmap.org',
  photonUrl: 'https://photon.komoot.io',
  osrmUrl: 'https://router.project-osrm.org',
};

const resolveProvider = (value?: string): MapProvider => {
  if (!value || value === 'osm') return 'osm';
  if (value === 'google') return 'google';
  console.warn(`Unknown VITE_MAP_PROVIDER "${value}", falling back to osm`);
  return 'osm';
};

// Пустая строка означает «не задано»
const resolveUrl = (value: string | undefined, fallback: string): string =>
  (value || fallback).replace(/\/+$/, '');

export function resolveGeoConfig(raw: RawGeoEnv): GeoConfig {
  return {
    provider: resolveProvider(raw.mapProvider),
    googleApiKey: raw.googleMapsApiKey || '',
    osm: {
      nominatimUrl: resolveUrl(raw.nominatimUrl, DEFAULT_OSM_ENDPOINTS.nominatimUrl),
      photonUrl: resolveUrl(raw.photonUrl, DEFAULT_OSM_ENDPOINTS.photonUrl),
      osrmUrl: resolveUrl(raw.osrmUrl, DEFAULT_OSM_ENDPOINTS.osrmUrl),
    },
  };
}

export const geoConfig: GeoConfig = resolveGeoConfig({
  mapProvider,
  googleMapsApiKey,
  nominatimUrl: osmNominatimUrl,
  photonUrl: osmPhotonUrl,
  osrmUrl: osmOsrmUrl,
});
